import { Button, ButtonProps } from 'common/Button'
import { theme } from 'lib/theme'

export const VideoAssetControl: React.FC<{ show: boolean } & ButtonProps> = ({
  show,
  children,
  onClick,
  css
}) => (
  <Button
    icon
    css={{
      transition: 'opacity 125ms ease-in-out',
      opacity: show ? 1 : 0,
      position: 'absolute',
      backgroundColor: theme.colors.gray100,
      width: '28px',
      height: '28px',
      minWidth: '28px',
      minHeight: '28px',
      zIndex: theme.zIndices.layerOne,
      ...css
    }}
    onClick={(ev) => {
      if (show) {
        ev.stopPropagation()
        onClick?.(ev)
      }
    }}
  >
    {children}
  </Button>
)
